import React from 'react';

import { AGENT_MESSAGE_DIRECTION, IAgentMessage } from '../agent-sdk/message';

interface Interface {
  message: IAgentMessage;
  imageMaxWidth?: string;
  fontSize?: string;
  handleSubmitOpinion?: any;
  handleSubmitUserInfo?: any;
  handleSubmitFeedback?: any;
  handleSubmitOfflineMsg?: any;
  handleSubmitAdvisoryType?: any;
}

// matchURL 匹配出字符串中的 url 开始和结束位置
function matchURL(data: string) {
  const result = [];
  const regExp = new RegExp(
    "(ht|f)tp(s?)://[0-9a-zA-Z]([-.w]*[0-9a-zA-Z])*(:(0-9)*)*(/?)([a-zA-Z0-9-.?,'/\\+&amp;%$#_=]*)?",
    'g'
  );
  for (let i = regExp.exec(data); i !== null; i = regExp.exec(data)) {
    result.push({ index: i.index, data: i[0] });
  }
  return result;
}

// PickURLElements 提取文本中的链接转化为 a 标签
function PickURLElements(data: string) {
  const dataUrl = matchURL(data);
  const renderElement = new Array<JSX.Element>();
  let p = 0;
  for (const i of dataUrl) {
    renderElement.push(
      <React.Fragment key={`fra-${i}`}>
        {data.slice(p, i.index)}
      </React.Fragment>,
      <a key={`a-${i}`} className="underline" href={i.data} target="_blank">
        {i.data}
      </a>
    );
    p = i.index + i.data.length;
  }
  renderElement.push(
    <React.Fragment key={`fra-${p}`}> {data.slice(p)} </React.Fragment>
  );
  return renderElement;
}

function TextContent(props: Interface) {
  const className = 'whitespace-pre-line break-all font-sans font-medium p-2';
  return (
    <pre style={{ fontSize: props.fontSize }} className={className}>
      {PickURLElements(props.message.data.content)}
    </pre>
  );
}

function HTMLContent(props: Interface) {
  const className = 'break-all font-sans font-medium p-2 agentBubbleContent';
  // 只有系统可以发送HTML
  if (props.message.direction !== AGENT_MESSAGE_DIRECTION.TO_ANONYMOUS) {
    return <TextContent {...props}></TextContent>;
  }
  return (
    <div
      style={{ fontSize: props.fontSize }}
      className={className}
      dangerouslySetInnerHTML={{ __html: props.message.data.content }}
    ></div>
  );
}

export default function AgentBubbleContent(props: Interface) {
  // 正常信息
  switch (props.message.direction) {
    case AGENT_MESSAGE_DIRECTION.TO_AGENT:
      return <TextContent {...props} />;
    case AGENT_MESSAGE_DIRECTION.TO_ANONYMOUS:
      return <HTMLContent {...props} />;
    default:
      return <TextContent {...props} />;
  }
}
